





export default {
  name: 'SidebarContent',
};
